import CLC2UniMentorPage from "./CLC2UniMentorPage";

export default CLC2UniMentorPage;
